import { Placements } from '../types/index.js';

const ARROW_OFFSET = {
    VERTICAL: '-11px'};
const PLACEMENT_MAP = {
    [Placements.Auto]: 'top-center',
    [Placements.AutoStart]: 'top-right',
    [Placements.AutoEnd]: 'top-left',
    [Placements.Top]: 'top-center',
    [Placements.TopStart]: 'top-right',
    [Placements.TopEnd]: 'top-left',
    [Placements.Bottom]: 'bottom-center',
    [Placements.BottomStart]: 'bottom-right',
    [Placements.BottomEnd]: 'bottom-left',
    [Placements.Left]: 'middle-left',
    [Placements.LeftStart]: 'middle-left',
    [Placements.LeftEnd]: 'middle-left',
    [Placements.Right]: 'middle-right',
    [Placements.RightStart]: 'middle-right',
    [Placements.RightEnd]: 'middle-right',
};
const mapPlacement = (placement) => PLACEMENT_MAP[placement] || 'bottom-center';
const getArrowStyle = (placement, referenceWidth) => {
    let left;
    let right;
    let transform;
    let top;
    if (placement === Placements.Left || placement === Placements.LeftStart || placement === Placements.LeftEnd) {
        left = undefined;
        right = '-15px';
        transform = 'translateY(-50%)';
        top = '50%';
    }
    if (placement === Placements.Right || placement === Placements.RightStart || placement === Placements.RightEnd) {
        left = undefined;
        left = '-15px';
        transform = 'translateY(-50%)';
        top = '50%';
    }
    if (placement === Placements.Top || placement === Placements.Auto) {
        left = '50%';
        right = undefined;
        transform = 'translateX(-50%)';
    }
    if (placement === Placements.TopStart || placement === Placements.AutoStart) {
        right = referenceWidth
            ? `${referenceWidth / 2}px`
            : '0px';
        left = undefined;
        transform = undefined;
    }
    if (placement === Placements.TopEnd || placement === Placements.AutoEnd) {
        right = undefined;
        left = referenceWidth
            ? `${referenceWidth / 2}px`
            : '100%';
        transform = undefined;
    }
    if (placement === Placements.Bottom) {
        left = '50%';
        right = undefined;
        transform = 'translateX(-50%)';
    }
    if (placement === Placements.BottomEnd) {
        right = undefined;
        left = referenceWidth
            ? `${referenceWidth / 2}px`
            : '100%';
        transform = undefined;
    }
    if (placement === Placements.BottomStart) {
        right = referenceWidth
            ? `${referenceWidth / 2}px`
            : '0px';
        left = undefined;
        transform = undefined;
    }
    return {
        left,
        right,
        transform,
        ...(placement.startsWith('top') || placement.startsWith('auto')
            ? { bottom: ARROW_OFFSET.VERTICAL }
            : placement.startsWith('bottom')
                ? { top: ARROW_OFFSET.VERTICAL }
                : { top }),
    };
};

export { getArrowStyle, mapPlacement };
